import {
    booleanFormatter,
    healthColorAlertFormatter, integerFormatter,
    removeURIEncode, ServiceNowButton
} from "../../gridFormatters";


export const switchHealthAlertDefs = [
    {
      field: "id",
        headerName: 'ID'
    },
    {
        "field": "severity",
        "headerName": "Severity",
        "cellRenderer": healthColorAlertFormatter
    },
    {
        "field": "device_name",
        "headerName": "Device Name"
    },
    {
        "field": "category",
        "headerName": "Category",
    },
    {
        "field": "alert",
        "headerName": "Alert",
        "cellRenderer": removeURIEncode,
    },
    {
        "field": "alert_target",
        "headerName": "Alert Target",
        "cellRenderer": removeURIEncode,
    },
    {
        "field": "description",
        "headerName": "Description",
        "cellRenderer": removeURIEncode,
    },
      {
        "field": "acknowledged",
        "headerName": "Acknowledged?",
        "cellRenderer": booleanFormatter,
    },
    {
        "field": "incident_id",
        "headerName": "Service Now",
        "cellRenderer": ServiceNowButton
    }
];